"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[110],{

/***/ 76924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "clip-path": "url(#clip0_182461_28474)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        "fill-opacity": "0.01"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M17.1436 1.07143H14.7328V0.178571C14.7328 0.0803571 14.6525 0 14.5543 0H13.3043C13.2061 0 13.1257 0.0803571 13.1257 0.178571V1.07143H9.73284V0.178571C9.73284 0.0803571 9.65248 0 9.55427 0H8.30427C8.20605 0 8.1257 0.0803571 8.1257 0.178571V1.07143H5.71498C5.31989 1.07143 5.0007 1.39062 5.0007 1.78571V4.46429H2.85784C2.46275 4.46429 2.14355 4.78348 2.14355 5.17857V19.2857C2.14355 19.6808 2.46275 20 2.85784 20H14.2864C14.6815 20 15.0007 19.6808 15.0007 19.2857V17.1429H17.1436C17.5386 17.1429 17.8578 16.8237 17.8578 16.4286V1.78571C17.8578 1.39062 17.5386 1.07143 17.1436 1.07143ZM13.3936 18.3929H3.7507V6.07143H8.61677V9.95536C8.61677 10.4487 9.01632 10.8482 9.50963 10.8482H13.3936V18.3929ZM13.3936 9.41964H10.0453V6.07143H10.0498L13.3936 9.41518V9.41964ZM16.2507 15.5357H15.0007V8.75L10.715 4.46429H6.60784V2.67857H8.1257V3.39286C8.1257 3.49107 8.20605 3.57143 8.30427 3.57143H9.55427C9.65248 3.57143 9.73284 3.49107 9.73284 3.39286V2.67857H13.1257V3.39286C13.1257 3.49107 13.2061 3.57143 13.3043 3.57143H14.5543C14.6525 3.57143 14.7328 3.49107 14.7328 3.39286V2.67857H16.2507V15.5357Z",
                        fill: "#EDA426"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_182461_28474",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 89233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ airdrop_screen; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Paste.tsx
var Paste = __webpack_require__(76924);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 24 modules
var typography = __webpack_require__(46930);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 24 modules
var es_form = __webpack_require__(82601);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 11 modules
var message = __webpack_require__(10154);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/antd/es/flex/index.js + 3 modules
var flex = __webpack_require__(51431);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 14 modules
var es_button = __webpack_require__(89779);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/index.ts + 56 modules
var state = __webpack_require__(57868);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(13193);
// EXTERNAL MODULE: ./node_modules/react-meta-tags/lib/index.js
var lib = __webpack_require__(81372);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./src/config/constants/meta.ts
var meta = __webpack_require__(31574);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Menu/config.ts
var config = __webpack_require__(4449);
;// CONCATENATED MODULE: ./src/components/Layout/PageFullWidth.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1320px;\n    margin: auto;\n    padding: 0px 0px 20px 0px;\n    min-height: ",
        ";\n    @media screen and (max-width: 576px) {\n        min-height: ",
        ";\n    }\n    @media screen and (max-width: 1200px) {\n        padding: 0px 16px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// import { useLocation } from 'react-router'



var PageMeta = function() {
    var ref = (0,src/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var pathname = (0,router.useRouter)().pathname;
    var pageMeta = (0,meta/* getCustomMeta */.S)(pathname, t, locale) || {};
    var ref1 = (0,_object_spread/* default */.Z)({}, meta/* DEFAULT_META */.k, pageMeta), title = ref1.title, description = ref1.description, image = ref1.image;
    var pageTitle = title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: image
            })
        ]
    });
};
var PageFullWidth = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta, {}),
            children
        ]
    });
};
/* harmony default export */ var Layout_PageFullWidth = (PageFullWidth);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-af454bb0-0"
})(_templateObject(), function() {
    return "calc(100vh - ".concat(config/* MENU_HEIGHT */.d0, "px)");
}, function() {
    return "calc(100vh - ".concat(config/* MENU_HEIGHT */.d0 + 110, "px)");
});

// EXTERNAL MODULE: ./src/state/airdrop/action.ts + 1 modules
var action = __webpack_require__(40034);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/state/airdrop/selector.ts

var useAirdropSelector = function() {
    var data = (0,es/* useSelector */.v9)(function(state) {
        return state.airdrop;
    });
    return data;
};

// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/config/api/airdrop.ts + 1 modules
var api_airdrop = __webpack_require__(3614);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
;// CONCATENATED MODULE: ./src/views/00_Airdrop/styled.tsx

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    width: 100vw;\n    height: 100%;\n    position: fixed;\n    z-index: 0;\n    left: 0;\n    bottom: 110px;\n    top: 0;\n    background: url("/images/tonusd/bg.jpg");\n    background-position: center center;\n    background-size: 100%;\n    background-repeat: no-repeat;\n    z-index: -1;\n    @media screen and (max-width:768px) {\n        display: none;\n    }\n'
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    min-height: 90vh;\n    z-index: 10;\n    padding-left: 1rem;\n    @media screen and (max-width:768px) {\n        padding-left: 0rem;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        padding-top: 32px;\n        min-height: calc(100vh - 100px);\n    }\n    @media screen and (max-width:576px) {\n        margin-bottom: 2rem;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 332px;\n    max-width: 1000px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 550px;\n    height: 100%;\n    min-height: 100px;\n    @media screen and (max-width: 768px) {\n        width: 550px;\n        padding: 2rem 2rem;\n        box-shadow: 0px 0px 1.5px 0px #FFFFFF4D inset;\n        background: #FFFFFF0D;\n        border-radius: 16px;\n    }\n    @media screen and (max-width: 576px) {\n        width: 100%;\n        padding: 2rem 1rem;\n    } \n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: white;\n    font-size: 29px;\n    text-align: left;\n    font-weight: 700;\n    text-transform: uppercase;\n    @media screen and (max-width:576px) {\n        font-size: 22px;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    background: #EDA426;\n    color: white;\n    box-shadow: 0px 3.22px 3.22px 0px #00000040;\n    border-radius: 8px;\n    border: none;\n    font-size: 16px;\n    height: 40px;\n    &:hover {\n        color: white !important;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #EDA426;\n    font-weight: 700;\n    font-size: 62px;\n    @media screen and (max-width: 576px) {\n        font-size: 42px;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var ContainerMask = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-690f301c-0"
})(styled_templateObject());
var ContainerAirdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-690f301c-1"
})(_templateObject1());
var ContainerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-690f301c-2"
})(_templateObject2());
var ContainerImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-690f301c-3"
})(_templateObject3());
var ContainerFormSubmit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-690f301c-4"
})(_templateObject4());
var CsTextHeading = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-690f301c-5"
})(_templateObject5());
var CsButtonSubmit = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.ZP).withConfig({
    componentId: "sc-690f301c-6"
})(_templateObject6());
var CsTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-690f301c-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/views/00_Airdrop/airdrop_screen.tsx
//node_modules








//components

//actions

//selector

//function

//constants
//styled


var airdrop_screen_Text = typography/* default.Text */.Z.Text;
var ComingSoonScreen = function() {
    // -------------------------- VAR ---------------------------
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    // -------------------------- STATE -------------------------
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    // -------------------------- REDUX -------------------------
    var dispath = (0,state/* useAppDispatch */.TL)();
    var airdrop = useAirdropSelector();
    var isWhitelist = airdrop.isWhitelist, tonWallet = airdrop.tonWallet;
    // -------------------------- FUNCTION ----------------------
    var handleSubmit = function() {
        setLoading(true);
        form.validateFields().then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                var response, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                api_airdrop/* airdropApi.postAddWallet */.G.postAddWallet({
                                    bscWallet: account,
                                    tonWallet: res === null || res === void 0 ? void 0 : res.accountTon
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            console.log("response", response);
                            if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                                message/* default.success */.ZP.success({
                                    content: "Successfully submitted the TON wallet address",
                                    duration: 1
                                });
                                dispath((0,action/* fetchTonWalletByBscWallet */.q)({
                                    bscWallet: account
                                }));
                                dispath((0,action/* fetchIsWhitelist */.s)({
                                    bscWallet: account
                                }));
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log("Submit failed:", error);
                            message/* default.error */.ZP.error({
                                content: "Something went wrong. Please try to again!",
                                duration: 1
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(err) {
            console.log(err);
        }).finally(function() {
            setLoading(false);
        });
    };
    var handlePaste = function() {
        if (!Boolean(tonWallet)) {
            navigator.clipboard.readText().then(function(clipText) {
                form.setFieldValue("accountTon", clipText);
            });
        }
    };
    // -------------------------- EFFECT ------------------------
    (0,react.useEffect)(function() {
        if (Boolean(tonWallet)) {
            form.setFieldValue("accountTon", tonWallet);
        } else {
            form.setFieldValue("accountTon", "");
        }
    }, [
        tonWallet
    ]);
    (0,react.useEffect)(function() {
        dispath((0,action/* fetchTonWalletByBscWallet */.q)({
            bscWallet: account
        }));
        dispath((0,action/* fetchIsWhitelist */.s)({
            bscWallet: account
        }));
    }, [
        account
    ]);
    var err = (0,react.useMemo)(function() {
        if (!account) {
            return "Please connect wallet to continue";
        }
        if (account && !isWhitelist) {
            return "You need to connect the wallet address that was used to participate in the private sale of the CATO project.";
        }
        return null;
    }, [
        account,
        isWhitelist
    ]);
    // -------------------------- RENDER ------------------------
    // -------------------------- MAIN --------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_PageFullWidth, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerAirdrop, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerFormSubmit, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        gutter: [
                            0,
                            24
                        ],
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    gutter: [
                                        0,
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            span: 24,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTitle, {
                                                children: "Receive SHAT Token"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            span: 24,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextHeading, {
                                                children: "Enter your TON wallet address to receive the corresponding SHAT tokens."
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default */.Z, {
                                    name: "submit-whitelist",
                                    autoComplete: "off",
                                    form: form,
                                    size: "large",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                        name: "accountTon",
                                        rules: [
                                            {
                                                required: true,
                                                message: "Please enter TON address"
                                            }, 
                                        ],
                                        validateTrigger: [
                                            "onChange",
                                            "onBlur"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                            placeholder: "TON Address",
                                            readOnly: Boolean(tonWallet),
                                            suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paste/* default */.Z, {
                                                style: {
                                                    cursor: Boolean(tonWallet) ? "not-allowed" : "pointer"
                                                },
                                                onClick: handlePaste
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* default */.Z, {
                                    vertical: true,
                                    gap: 8,
                                    children: [
                                        Boolean(err) && /*#__PURE__*/ (0,jsx_runtime.jsx)(airdrop_screen_Text, {
                                            type: "danger",
                                            children: err
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                            onClick: handleSubmit,
                                            disabled: !account || !isWhitelist || isLoading || Boolean(tonWallet),
                                            type: "primary",
                                            style: {
                                                width: "100%"
                                            },
                                            size: "large",
                                            children: Boolean(tonWallet) ? "Submitted" : "Submit"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMask, {})
        ]
    });
};
/* harmony default export */ var airdrop_screen = (ComingSoonScreen);


/***/ })

}]);